import React from 'react'
import { Columns } from 'react-bulma-components'

const ComponentFooter = ({
  children,
  ...rest
}: {
  children: React.ReactNode
  [key: string]: any
}): JSX.Element => (
  <Columns mt={5} {...rest}>
    {children}
  </Columns>
)
const Left: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => (
  <Columns.Column>{children}</Columns.Column>
)
const Right: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => (
  <Columns.Column narrow>{children}</Columns.Column>
)
ComponentFooter.Left = Left
ComponentFooter.Right = Right
export default ComponentFooter
